import React from 'react';
import { useIsNative } from '~/context/common/DeviceContext';

type OwnProps = React.PropsWithChildren<{
  /** Specify if the children should be hidden on native. Defaults to `true`. */
  hide?: boolean;
}>;

export default function HideOnNative({ children, hide = true }: OwnProps) {
  const isNative = useIsNative();

  return isNative && hide ? null : <>{children}</>;
}
